import React from 'react';

import { Icon } from '../common/Icon';

export function AwaitingIcon({ awaiting }) {
  return <Icon icon={awaiting ? 'notifications' : 'check_circle_outline'}
               title={awaiting ? 'Awaiting action from us' : 'Done. No direct action needed'}
               level={awaiting ? 'primary' : 'success'}/>;
}
